module.exports = __webpack_public_path__ + "img/wait-tendering@3x.0f4c1dc2.png";